<template>
  <div class="calendar-grid" :style="gridStyle">
    <slot />
  </div>
</template>

<script setup lang="ts">
import type { Moment } from 'moment'
import { computed } from 'vue'
import {
  generateCalendarGridTemplateColumns,
  getDaysForPeriod,
} from '@/components/weekly-schedule/utils'
const props = defineProps<{
  start: Moment
  end: Moment
  offsetLeft?: `${number}px` | `var(--${string})` | `var(--${string}, ${number}px)`
}>()

const dayRange = computed(() => getDaysForPeriod(props.start, props.end))
const weekStart = computed(() => dayRange.value[0]?.name ?? 'sun')
const weekEnd = computed(() => dayRange.value[dayRange.value.length - 1]?.name ?? 'sat')

const gridStyle = computed(() => {
  return {
    '--week-start': `${weekStart.value}-start`,
    '--week-end': `${weekEnd.value}-end`,
    'grid-template-columns': generateCalendarGridTemplateColumns(dayRange.value, {
      offsetLeft: props.offsetLeft,
    }),
  }
})
</script>

<style scoped>
.calendar-grid {
  display: grid;
}
</style>
